import { useMemo } from 'react';

import { Application, Category } from '../providers/Applications.types';
import { useApplicationsContext, useCategoriesContext } from '../providers/ApplicationsProvider';
import { mapApplicationsToCategories } from '../utils/mapApplicationsToCategories';

type MappedApplications = {
  applications: Application[];
  category: Category;
};

export function useMappedApplications(): MappedApplications[] {
  const categories = useCategoriesContext();
  const applications = useApplicationsContext();

  const mappedApplications = useMemo(() => {
    return mapApplicationsToCategories({ categories, applications });
  }, [categories, applications]);

  return mappedApplications;
}
